import { createSelector } from "reselect";
import { isAttachmentFile } from "~/utils/files";
import { getAllAttachments } from "./selector.attachments";
import { getLoggedUser } from "./selector.users";

export const getAllFiles = (state) => state.files;
export const getFileById = (state, id) => state.files.get(`${id}`);

export const getActiveFiles = createSelector(getAllFiles, (files) => files.filter((file) => !file.get("is_trashed")));

export const makeGetFileOrAttachmentByTypeAndId = (type, id) => {
  return createSelector(getAllFiles, getAllAttachments, (files, attachments) => {
    if (/File$/i.test(type)) {
      return files.get(`${id}`);
    } else if (isAttachmentFile(type)) {
      return attachments.get(`${id}`);
    }
    return null;
  });
};

export const makeGetFilePermissionSelector = (id) => {
  return createSelector(
    (state) => getFileById(state, id),
    getLoggedUser,
    (file, user) => {
      const canManageTasks = user?.custom_permissions.some((value) => value === "can_manage_tasks");

      let permissions = {
        create: true,
        read: !!file,
        update: !!file,
        delete: !!file,
        restore: user?.class === "Owner" || file?.get("trashed_by_id") === user?.id,
      };

      if (user?.class === "Client") {
        permissions.create = false;
        permissions.read = true;
        permissions.update = false;
        permissions.delete = false;

        if (canManageTasks) {
          permissions.create = true;
          permissions.update = permissions.delete = user?.id === file?.get("created_by_id");
        }
      }

      return permissions;
    }
  );
};
